import { showToast } from "@/providers/ToastProvider";

export function showCoSignToast({
  isCoSignRequired,
  providerName,
}: {
  isCoSignRequired: boolean;
  providerName: string;
}) {
  showToast([
    {
      heading: isCoSignRequired
        ? `Co-signature now required for ${providerName}. New notes will be routed to supervisors.`
        : `Co-signature no longer required for ${providerName}. New notes will be finalized on signing.`,
      variant: "success",
    },
    { delay: 500 },
  ]);
}
